import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { formatDate } from '../../lib/dateUtils';

/**
 * 5 tarjetas de KPIs principales del ROI de un lote.
 */
export const ResumenKPIs = ({ resumen }) => {
  if (!resumen) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-4">
          <p className="text-xs font-medium text-muted-foreground">Total Invertido</p>
          <p
            className="text-xl font-bold tabular-nums mt-1 text-destructive"
            style={{ fontFamily: 'Space Grotesk' }}
          >
            ${resumen.total_gastos?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
          </p>
          <p className="text-[10px] text-muted-foreground mt-1">acumulado</p>
        </CardContent>
      </Card>
      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-4">
          <p className="text-xs font-medium text-muted-foreground">Costo / Gallina</p>
          <p className="text-xl font-bold tabular-nums mt-1" style={{ fontFamily: 'Space Grotesk' }}>
            ${resumen.costo_por_gallina?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
          </p>
          <p className="text-[10px] text-muted-foreground mt-1">
            {resumen.total_gallinas?.toLocaleString('es-ES')} gallinas
          </p>
        </CardContent>
      </Card>
      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-4">
          <p className="text-xs font-medium text-muted-foreground">Ingresos (Ventas)</p>
          <p
            className="text-xl font-bold tabular-nums mt-1 text-green-600"
            style={{ fontFamily: 'Space Grotesk' }}
          >
            ${resumen.total_ingresos?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
          </p>
          <p className="text-[10px] text-muted-foreground mt-1">desde postura</p>
        </CardContent>
      </Card>
      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-4">
          <p className="text-xs font-medium text-muted-foreground">% Recuperado</p>
          <p
            className="text-xl font-bold tabular-nums mt-1"
            style={{
              fontFamily: 'Space Grotesk',
              color: resumen.porcentaje_recuperado >= 100 ? '#16A34A' : '#E67E22',
            }}
          >
            {resumen.porcentaje_recuperado}%
          </p>
          <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2">
            <div
              className="h-1.5 rounded-full transition-all duration-500"
              style={{
                width: `${Math.min(resumen.porcentaje_recuperado, 100)}%`,
                backgroundColor: resumen.porcentaje_recuperado >= 100 ? '#16A34A' : '#E67E22',
              }}
            />
          </div>
        </CardContent>
      </Card>
      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-4">
          <p className="text-xs font-medium text-muted-foreground">
            {resumen.ganancia_neta > 0 ? 'Ganancia Neta' : 'Inversion Pendiente'}
          </p>
          <p
            className={`text-xl font-bold tabular-nums mt-1 ${
              resumen.ganancia_neta > 0 ? 'text-green-600' : 'text-amber-600'
            }`}
            style={{ fontFamily: 'Space Grotesk' }}
          >
            ${(resumen.ganancia_neta > 0
              ? resumen.ganancia_neta
              : resumen.inversion_pendiente
            )?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
          </p>
          {resumen.estimado_breakeven && (
            <p className="text-[10px] text-muted-foreground mt-1">
              {resumen.estimado_breakeven === 'YA RECUPERADO'
                ? 'Inversion recuperada!'
                : `Est. recuperacion: ${formatDate(resumen.estimado_breakeven)}`}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
